<template>

    <v-card color="#f5f5f5" v-observe-visibility="visibilityChanged">

        <v-toolbar :extension-height="$vuetify.breakpoint.lgAndDown ? 150 : 62"
                   fixed light color="white">
            <v-btn icon @click.native="closeDialog" light>
                <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Confirm Order Position {{selectedOrderPosition.id}} -
                {{selectedItem.purchase_orders_number}}
            </v-toolbar-title>
            <v-spacer></v-spacer>

            <v-layout row wrap slot="extension">

                <v-flex xs12 lg12>
                    <v-layout>
                        <v-flex sm12 md1 pl-4 pa-2>
                            <v-text-field
                                    label="Position-ID"
                                    :value="selectedOrderPosition.id"
                                    readonly
                            ></v-text-field>
                        </v-flex>

                        <v-flex sm12 md2 pl-4 pa-2>
                            <v-text-field
                                    label="Manufacturer"
                                    :value="selectedOrderPosition.product.manufacturer.name"
                                    readonly
                            ></v-text-field>
                        </v-flex>

                        <v-flex sm12 md3 pl-4 pa-2>
                            <v-text-field
                                    label="Item-Number"
                                    :value="selectedOrderPosition.product.reference"
                                    readonly
                            ></v-text-field>
                        </v-flex>

                        <v-flex sm12 md1 pl-4 pa-2>
                            <v-text-field
                                    label="Quantity"
                                    :value="selectedOrderPosition.quantity"
                                    readonly
                            ></v-text-field>
                        </v-flex>

                        <v-flex sm12 md1 pl-4 pa-2>
                            <v-text-field
                                    label="Unit"
                                    :value="selectedOrderPosition.unit.code"
                                    readonly
                            ></v-text-field>
                        </v-flex>

                    </v-layout>

                </v-flex>

            </v-layout>

        </v-toolbar>

        <div v-show="$vuetify.breakpoint.lgAndDown" style="height: 96px"></div>

        <v-layout row wrap pt-5>
            <v-layout row wrap pt-5>
                <v-layout row wrap pt-5>
                </v-layout>
            </v-layout>
        </v-layout>
        <v-layout row wrap>
            <v-flex pl-4 pr-4>

                <v-layout row wrap>
                    <v-flex xs12 md4 pl-4 pt-4 pa-2>
                        <v-card>
                            <v-card-title><h4>Descriptions / Remark</h4></v-card-title>
                            <v-divider></v-divider>
                            <v-layout row wrap pt-4>
                                <v-flex xs12 pl-4 pr-4>
                                    <v-textarea v-model="selectedOrderPosition.customers_offers_position.description"
                                                auto-grow
                                                label="Customer Description"
                                                readonly
                                    ></v-textarea>
                                </v-flex>
                                <v-flex xs12 pl-4 pr-4>
                                    <v-textarea
                                            :value="selectedOrderPosition.product.product_description.description"
                                            auto-grow
                                            label="Product Description"
                                            readonly
                                    ></v-textarea>
                                </v-flex>
                                <v-flex xs12 pl-4 pr-4>
                                    <v-textarea
                                            auto-grow
                                            rows="4"
                                            label="Order Confirmation Description"
                                            box
                                            v-model="selectedOrderPosition.description"
                                    ></v-textarea>
                                </v-flex>
                                <v-flex xs12 pl-4 pr-4>
                                    <v-textarea
                                            auto-grow
                                            rows="4"
                                            label="Order Confirmation Remark"
                                            box
                                            v-model="selectedOrderPosition.remark"
                                    ></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-card>
                    </v-flex>

                    <v-flex xs12 md8 pl-4 pt-4 pa-2 pb-5>
                        <v-card>
                            <v-card-title><h4>Confirm Order Position Values</h4></v-card-title>
                            <v-divider></v-divider>


                            <v-layout row wrap pt-4 pr-4 pl-4>

                                <v-flex xs12 pt-2 pl-4 pr-4>
                                    <v-layout wrap>
                                        <v-subheader>Selected Supplier offer</v-subheader>
                                        <v-spacer></v-spacer>
                                    </v-layout>
                                </v-flex>

                                <v-flex xs12 pb-4 pl-4 pr-4>
                                    <v-divider></v-divider>
                                </v-flex>


                                <v-flex xs12 md4 pl-4 pr-4>
                                    <v-text-field
                                            label="Supplier Name"
                                            v-model="selectedOrderPosition.supplier_offers_position.suppliers_offer.supplier.name"
                                            readonly
                                    ></v-text-field>
                                </v-flex>


                                <v-flex xs12 md2 pl-4 pr-4>
                                    <v-text-field
                                            label="Delivery Time"
                                            v-model="selectedOrderPosition.supplier_offers_position.delivery_time.value"
                                            type="number"
                                            step=".01"
                                            min="0"
                                            readonly
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs12 md2 pl-4 pr-4>
                                    <v-autocomplete
                                            v-model="selectedOrderPosition.supplier_offers_position.delivery_time.delivery_times_types_id"
                                            :items="getDeliveryTimeTypes"
                                            label="Type"
                                            item-value="id"
                                            item-text="name"
                                            readonly
                                    ></v-autocomplete>
                                </v-flex>

                                <v-flex xs12 md4 pl-4 pr-4>
                                    <v-text-field
                                            :suffix="selectedOrderPosition.supplier_offers_position.suppliers_offer.currency.name"
                                            label="Unit Purchase Price"
                                            v-model="calculateSupplierOfferUnitPriceFormatted"
                                            readonly
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs12 md3 pl-4 pr-4>
                                    <DocumentTokenChip
                                            v-show="selectedOrderPosition.supplier_offers_position.suppliers_offer.documents_id !== 0"
                                            :documentsId="selectedOrderPosition.supplier_offers_position.suppliers_offer.documents_id"
                                            :documentFilename="selectedOrderPosition.supplier_offers_position.suppliers_offer.offer_number + '.pdf'"
                                    >
                                    </DocumentTokenChip>
                                </v-flex>

                                <v-flex xs12 pt-2 pl-4 pr-4>
                                    <v-layout wrap>
                                        <v-subheader>Customer offer</v-subheader>
                                        <v-spacer></v-spacer>
                                    </v-layout>
                                </v-flex>

                                <v-flex xs12 pb-4 pl-4 pr-4>
                                    <v-divider></v-divider>
                                </v-flex>


                                <v-flex xs12 md4 pl-4 pr-4>
                                    <v-text-field
                                            label="Customer Name"
                                            v-model="selectedOrderPosition.customers_offers_position.customers_offer.customer.name"
                                            readonly
                                    ></v-text-field>
                                </v-flex>


                                <v-flex xs12 md2 pl-4 pr-4>
                                    <v-text-field
                                            label="Delivery Time"
                                            v-model="selectedOrderPosition.customers_offers_position.delivery_time.value"
                                            type="number"
                                            step=".01"
                                            min="0"
                                            readonly
                                    ></v-text-field>

                                </v-flex>

                                <v-flex xs12 md2 pl-4 pr-4>
                                    <v-autocomplete
                                            v-model="selectedOrderPosition.customers_offers_position.delivery_time.delivery_times_types_id"
                                            :items="getDeliveryTimeTypes"
                                            label="Type"
                                            item-value="id"
                                            item-text="name"
                                            readonly
                                    ></v-autocomplete>
                                </v-flex>


                                <v-flex xs12 md4 pl-4 pr-4>
                                    <v-text-field
                                            :suffix="selectedOrderPosition.customers_offers_position.customers_offer.currency.name"
                                            label="Unit Sales Price"
                                            v-model="calculateCustomersOfferUnitPriceFormatted"
                                            readonly
                                    ></v-text-field>
                                </v-flex>


                                <v-flex xs12 md3 pl-4 pr-4>
                                    <DocumentTokenChip
                                            v-show="getDocumentsId !== 0"
                                            :documentsId="getDocumentsId"
                                            :documentFilename="selectedOrderPosition.customers_offers_position.customers_offer.offer_number + '.pdf'"
                                    >
                                    </DocumentTokenChip>
                                </v-flex>

                            </v-layout>

                            <v-flex pb-1>

                                <v-layout row wrap pt-2 pr-5 pl-5>
                                    <v-flex xs12 pt-2>
                                        <v-layout wrap>
                                            <v-subheader>Confirm Position Values</v-subheader>
                                            <v-spacer></v-spacer>
                                        </v-layout>
                                    </v-flex>

                                    <v-flex xs12 pb-4>
                                        <v-divider></v-divider>
                                    </v-flex>

                                    <v-flex xs12 md3 pl-4 pr-4>
                                        <v-text-field
                                                id="unitOrderSalesPrice"
                                                box
                                                :suffix="selectedOrderPosition.customers_offers_position.customers_offer.currency.name"
                                                label="Unit Sales-Price"
                                                v-model.lazy="unitOrderSalesPrice"
                                                v-money="money"
                                        ></v-text-field>
                                    </v-flex>


                                    <v-flex xs12 md3 pl-4 pr-4>
                                        <v-text-field
                                                label="Quantity"
                                                v-model="selectedOrderPosition.quantity"
                                                box
                                                type="number"
                                                min="1"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs12 md3 pl-4 pr-4>
                                        <v-text-field
                                                :suffix="selectedOrderPosition.customers_offers_position.customers_offer.currency.name"
                                                label="Total Sales-Price"
                                                v-model="calculatedTotalSalesPrice"
                                                readonly
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs12 md3 pl-4 pr-4>

                                    <v-autocomplete
                                            clearable
                                            :items="getUnits"
                                            label="Unit"
                                            v-model="selectedOrderPosition.units_id"
                                            item-value="id"
                                            item-text="name"
                                            box
                                    ></v-autocomplete>
                                    </v-flex>

                                    <v-flex xs12 md3 pl-4 pr-4>
                                        <DatetimePicker
                                                locale="de-DE"
                                                landscape
                                                dateOnly
                                                mysql
                                                :width="width = 500"
                                                label="Delivery Date"
                                                v-model="selectedOrderPosition.delivery_date"
                                                format="DD.MM.YYYY"
                                                box
                                        ></DatetimePicker>
                                    </v-flex>

                                    <v-flex xs12 md3 pl-4 pr-4>
                                        <v-text-field
                                                box
                                                label="NCM"
                                                v-model="selectedOrderPosition.ncm"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs12 md3 pl-4 pr-4>
                                        <v-text-field
                                                box
                                                label="Internal Number"
                                                v-model="selectedOrderPosition.internal_number"
                                        ></v-text-field>
                                    </v-flex>

                                  <v-flex xs12 md3 pl-4 pr-4>
                                    <v-autocomplete
                                      clearable
                                      :items="getVats"
                                      label="VAT/Tax"
                                      v-model="selectedOrderPosition.vats_id"
                                      item-value="id"
                                      item-text="name"
                                      box
                                    />
                                  </v-flex>
                                </v-layout>

                            </v-flex>

                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn :loading="loading" color="secondary" @click.native="savePurchaseOrderPosition()">
                                    CONFIRM
                                    ORDER POSITION
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>

            </v-flex>

        </v-layout>
    </v-card>

</template>

<script>
    import {
        Settings,
        PurchaseOrder,
        SupplierOfferPositions,
        PurchaseOrderPosition,
        VatSettings
    } from '../../../store/namespace-helper'

    import DocumentTokenChip from '../../Shared/DocumentTokenChip.vue'

    import DatetimePicker from '../../Shared/DatetimePicker.vue'
    import {$} from 'moneysafe'
    import {$$, subtractPercent} from 'moneysafe/ledger'

    import {VMoney} from 'v-money'

    export default {
      components: {
        DatetimePicker,
        DocumentTokenChip
      },
      name: 'ConfirmOrderPosition',
      data () {
        return {
          isVisible: false,
          rowsPerPageItems: [6, 8, 12],
          pagination: {
            rowsPerPage: 6
          },
          discountTypes: ['percent'],
          additionalCostTypes: ['percent', 'fixed'],
          allAccounts: [],
          loadingOfferForId: false,
          money: {
            decimal: ',',
            thousands: '.',
            prefix: '',
            suffix: '',
            precision: 2,
            masked: true /* doesn't work with directive */
          },
          unitOrderSalesPrice: null
        }
      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              console.log('tab visible, load data')
              this.loadCurrencies()
              this.loadUnits()
              this.loadTermsOfDeliveries()
              this.loadTermsOfPayments()
              this.loadSupplierOffers()
              this.loadDeliveryTimeTypes()
              this.loadAllAccounts()
              this.initUnitSalesPrice()
              this.loadVats()
            } else {

            }
          }
        },
        closeDialog () {
          this.$store.dispatch(PurchaseOrderPosition.actions.setSelectedPurchaseOrderPosition, null)
          this.$store.dispatch(PurchaseOrderPosition.actions.openCloseDialog)
        },
        loadCurrencies () {
          this.$store.dispatch(Settings.actions.loadAllCurrencies)
        },
        loadUnits () {
          this.$store.dispatch(Settings.actions.loadAllUnits)
        },
        loadTermsOfPayments () {
          this.$store.dispatch(Settings.actions.loadTermsOfPayments)
        },
        loadTermsOfDeliveries () {
          this.$store.dispatch(Settings.actions.loadTermsOfDeliveries)
        },
        loadSupplierOffers () {
          this.$store.dispatch(SupplierOfferPositions.actions.loadSupplierOfferPositionByProductID, this.selectedOrderPosition.products_id).then(response => {

          })
        },
        loadDeliveryTimeTypes () {
          this.$store.dispatch(Settings.actions.loadAllDeliveryTimeTypes)
        },
        savePurchaseOrderPosition () {
          let saveItem = {
            id: this.selectedOrderPosition.id,
            purchase_orders_positions_status_id: this.selectedOrderPosition.purchase_orders_positions_status_id,
            vats_id: this.selectedOrderPosition.vats_id,
            quantity: this.selectedOrderPosition.quantity,
            unit_sales_price: this.selectedOrderPosition.unit_sales_price,
            total_sales_price: this.selectedOrderPosition.total_sales_price,
            description: this.selectedOrderPosition.description,
            remark: this.selectedOrderPosition.remark,
            units_id: this.selectedOrderPosition.units_id,
            delivery_date: this.selectedOrderPosition.delivery_date,
            ncm: this.selectedOrderPosition.ncm,
            internal_number: this.selectedOrderPosition.internal_number
          }
          this.$store.dispatch(PurchaseOrderPosition.actions.savePurchaseOrderPosition, saveItem)
        },
        loadAllAccounts () {
          this.$store.dispatch(Settings.actions.loadAllAccounts).then(response => {
            this.allAccounts = response.data.data
          })
        },
        initUnitSalesPrice () {
          let element = document.getElementById('unitOrderSalesPrice')
          let event = new Event('input')
          if (typeof element !== 'undefined' && element !== null) {
            element.value = ''
            element.dispatchEvent(event)
            element.value = new Intl.NumberFormat('de-DE', {
              style: 'decimal',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2

            }).format(this.selectedOrderPosition.unit_sales_price)
            element.dispatchEvent(event)
          }
        },
        customContactFilter (item, queryText, itemText) {
          const isMatch = (test, query) => {
            return test.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
          }
          const query = queryText || ''
          const displayText = item.title + ' ' + item.firstname + ' ' + item.lastname
          const rc = isMatch(item.firstname, query) ||
                    isMatch(item.lastname, query) ||
                    isMatch(item.email, query) ||
                    isMatch(displayText, query)
          console.log(`filter: ${JSON.stringify(item)}, '${query}', ${JSON.stringify(itemText)} => ${rc}`)
          return rc
        },
        loadVats () {
          this.$store.dispatch(VatSettings.actions.loadAllVats)
        }
      },
      computed: {
        selectedItem () {
          console.log('selected purchase order: ' + JSON.stringify(this.$store.getters[PurchaseOrder.getters.getSelectedPurchaseOrder]))
          return this.$store.getters[PurchaseOrder.getters.getSelectedPurchaseOrder]
        },
        selectedOrderPosition () {
          console.log('selected order position: ' + JSON.stringify(this.$store.getters[PurchaseOrderPosition.getters.getSelectedPurchaseOrderPosition]))
          return this.$store.getters[PurchaseOrderPosition.getters.getSelectedPurchaseOrderPosition]
        },
        getVats () {
          return this.$store.getters[VatSettings.getters.getAllVats]
        },
        calculatedTotalSalesPrice () {
          this.selectedOrderPosition.total_sales_price = this.selectedOrderPosition.quantity * this.selectedOrderPosition.unit_sales_price
          return Intl.NumberFormat('de-DE', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(this.selectedOrderPosition.quantity * this.selectedOrderPosition.unit_sales_price)
        },
        getUnits () {
          return this.$store.getters[Settings.getters.getAllUnits]
        },
        getSupplierOfferPositions () {
          return this.$store.getters[SupplierOfferPositions.getters.getSupplierOfferPositions]
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        loadingSupplierOfferPositions () {
          return this.$store.getters[SupplierOfferPositions.getters.getLoadingSupplierOfferPosition]
        },
        getCurrencies () {
          return this.$store.getters[Settings.getters.getAllCurrencies]
        },
        termsOfPayment () {
          return this.$store.getters[Settings.getters.getTermsOfPayments]
        },
        termsOfDelivery () {
          return this.$store.getters[Settings.getters.getTermsOfDeliveries]
        },
        getExchangeRate () {
          if (this.selectedItem.customers_offer.currency.name !== null || typeof this.selectedItem.customers_offer.currency.name === 'undefined') {
            let currency = this.selectedItem.customers_offer.currency.name
            return this.$store.getters[Settings.getters.getExchangeRate].quotes['USD' + currency]
          }
          return 0.00
        },
        getDeliveryTimeTypes () {
          return this.$store.getters[Settings.getters.getAllDeliveryTimeTypes]
        },
        calculateSupplierOfferUnitSalesPriceFormatted () {
          return Intl.NumberFormat('de-DE', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(this.calculateSupplierOfferUnitSalesPrice)
        },
        calculateSupplierOfferUnitPriceFormatted () {
          return Intl.NumberFormat('de-DE', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(this.calculateSupplierOfferUnitPrice)
        },
        calculateCustomersOfferUnitPriceFormatted () {
          return Intl.NumberFormat('de-DE', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(this.selectedOrderPosition.customers_offers_position.unit_sales_price)
        },
        calculateSupplierOfferUnitPrice () {
          let unitPrice = this.selectedOrderPosition.supplier_offers_position.unit_price
          this.selectedOrderPosition.supplier_offers_position.discounts.forEach(function (item) {
            unitPrice = $$(
                        $(unitPrice),
                        subtractPercent(item.value)
                    ).$
          })
          return unitPrice
        },
        getDocumentsId () {
          if (this.selectedOrderPosition.customers_offers_position &&
                this.selectedOrderPosition.customers_offers_position.customers_offer &&
                this.selectedOrderPosition.customers_offers_position.customers_offer.message &&
                this.selectedOrderPosition.customers_offers_position.customers_offer.message.attachments
                ) {
            return this.selectedOrderPosition.customers_offers_position.customers_offer.message.attachments[0].documents_id
          } else {
            return 0
          }
        }
      },
      watch: {
        unitOrderSalesPrice: {
          handler (val) {
            if (val !== null) {
              console.log('confirmUnitSalesPrice: ' + val)
              let formatRemoved = val.replace(/\./g, '')
              formatRemoved = formatRemoved.replace(/,/g, '.')
              this.selectedOrderPosition.unit_sales_price = formatRemoved
            }
          }
        }
            /*        selectedOrderPosition: {
                      handler (val) {
                        console.log('selectedOrderPosition changed: ' + JSON.stringify(val))
                      },
                      deep: true
                    } */

      },
      directives: {money: VMoney}

    }
</script>


<style scoped>

    #menu-button {
        margin-top: 4px;
        width: 55px;
        height: 55px;
    }

    .fromTop {
        padding-top: 120px;
    }

    .fixSides::before {
        position: absolute;
        content: "";
        background-color: #1e336d;
        height: 100%;
        width: 110vw;
        top: 0px;
        left: -24px;
    }

    .overflow-hidden {
        overflow: hidden;
    }

    .horiz-scroll {
        overflow-y: hidden;
        overflow-x: auto;
    }

    .pdfbutton {
        margin-right: 0px;
    }


</style>



// WEBPACK FOOTER //
// src/components/PurchaseOrders/OrderPositions/ConfirmOrderPosition.vue